module.exports = __webpack_public_path__ + "img/2.04d907c4.png";